import type {
  ProjectMembersProjectState,
  ProjectMembersSliceState,
} from './projectMembers.types'

export const createEmptyProjectMembersProjectState =
  (): ProjectMembersProjectState => ({
    members: [],
    roles: [],
    loading: false,
    error: null,
  })

export const createInitialProjectMembersState = (): ProjectMembersSliceState => ({
  byProjectId: {},
})
